import styled from '@emotion/styled'
import {css} from '@emotion/react'
import {theme} from '../../../../theme'

// Header badge styles

export const AccountMeta = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[3]};
  width: 100%;
`

export const AccountIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: ${theme.radii.md};
  background-color: #f4f6fb;
  border: 1px solid ${theme.colors.border.light};
  color: ${theme.colors.text.muted};
`

export const AccountInfo = styled.div`
  flex: 1;
  min-width: 0;
`

export const AccountName = styled.span`
  display: block;
  font-size: ${theme.fontSizes.base};
  font-weight: ${theme.fontWeights.bold};
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const AccountEmailRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
  min-width: 0;
`

export const AccountEmail = styled.span`
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.regular};
  color: #546276;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`

export const AccountCode = styled.span`
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.regular};
  color: #546276;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
`

export const MetaDivider = styled.span`
  width: 1px;
  height: 12px;
  background-color: ${theme.colors.border.default};
  flex-shrink: 0;
`

export const LocationTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${theme.space[1]};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.bold};
  color: #000000;
  background-color: #d8fff8;
  padding: 6px 16px;
  border-radius: ${theme.radii.full};
  white-space: nowrap;
  flex-shrink: 0;
`

// StatusBadge - Link Completed (purchased) / Link Active (sent, unpurchased) / Link Expired (timed out).
const activeStatusStyles = css`
  background: #eaf3de;
  color: #27500a;
  border-color: #97c459;
`

const pendingStatusStyles = css`
  background: #fdf3d7;
  color: #7a5300;
  border-color: #e6c15a;
`

const expiredStatusStyles = css`
  background: #fde8e8;
  color: #7a0000;
  border-color: #e55a5a;
`

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: ${theme.fontSizes.xs};
  font-weight: ${theme.fontWeights.semibold};
  padding: ${theme.space[1]} ${theme.space[3]};
  border-radius: ${theme.radii.full};
  border: 0.5px solid transparent;
  white-space: nowrap;
  flex-shrink: 0;
  text-transform: uppercase;
  letter-spacing: 0.04em;

  ${({status}) =>
    status === 'pending'
      ? pendingStatusStyles
      : status === 'expired'
      ? expiredStatusStyles
      : activeStatusStyles}
`

export const RowActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
  flex-shrink: 0;
`

export const ButtonActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${theme.space[1]};
  font-family: ${theme.fonts.body};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.medium};
  color: ${theme.colors.text.primary};
  background: transparent;
  border: 1px solid ${theme.colors.border.default};
  border-radius: ${theme.radii.md};
  padding: ${theme.space[1]} ${theme.space[3]};
  cursor: pointer;
  white-space: nowrap;
  transition: background-color ${theme.transitions.fast},
    border-color ${theme.transitions.fast};

  &:hover {
    background-color: ${theme.colors.bg.secondary};
    border-color: ${theme.colors.border.strong};
  }
`

// Expanded body — locations

export const LocationsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${theme.space[2]} ${theme.space[1]};
  // margin-bottom: ${theme.space[3]};
`
export const LocationTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${theme.space[3]};
`

export const LocationsLabel = styled.div`
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.bold};
  // color: ${theme.colors.text.muted};
  color: ##64748b;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  // margin-right: ${theme.space[2]};
`

export const LocationsCount = styled.div`
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
  background: #dfe5f7;
  border-radius: 5px;
  padding: 4px 8px;
`

export const AddLocationButton = styled.button`
  // font-family: ${theme.fonts.body};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.bold};
  color: #5378fc;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: color ${theme.transitions.fast};

  &:hover {
    color: ${theme.colors.text.linkHover};
  }
`

export const LocationList = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${theme.colors.border.default};
  border-radius: ${theme.radii.lg};
  overflow: hidden;
`

export const LocationRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
  padding: ${theme.space[3]} ${theme.space[4]};
  background-color: ${theme.colors.bg.primary};
  transition: background-color ${theme.transitions.fast};

  &:not(:last-child) {
    border-bottom: 1px solid ${theme.colors.border.light};
  }

  &:hover {
    background-color: ${theme.colors.bg.secondary};
  }
`

export const LocationPin = styled.span`
  display: flex;
  align-items: center;
  color: ${theme.colors.text.secondary};
  flex-shrink: 0;
`
export const LocationTitleWrap = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 2px;
  flex-shrink: 0;
`
export const LocationListTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
`

export const LocationName = styled.span`
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.semibold};
  color: #1e293b;
  white-space: nowrap;
`

export const LocationCity = styled.span`
  font-size: ${theme.fontSizes.sm};
  color: #94a3b8;
  white-space: nowrap;
`
export const LocationEmailRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
  min-width: 0;
`

export const LocationEmail = styled.span`
  font-size: ${theme.fontSizes.sm};
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`

export const LocationCode = styled.span`
  font-size: ${theme.fontSizes.sm};
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
`

export const LocationMeta = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[3]};
  margin-left: auto;
  flex-shrink: 0;
`

export const SubsCount = styled.span`
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.regular};
  color: #64748b;
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 9999px;
  white-space: nowrap;
`

// PayBadge — two variants driven by billTo prop
const parentPayStyles = css`
  background: #308ce81a;
  color: #2563eb;
  padding: 3px 11px;
  border-radius: 9999px;
  border: 1px solid #2563eb;
`

const selfPayStyles = css`
  background: #d1fae5;
  color: #059669;
  padding: 3px 11px;
  border-radius: 9999px;
  border: 1px solid #059669;
`

export const PayBadge = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.medium};
  padding: ${theme.space[1]} ${theme.space[3]};
  border-radius: ${theme.radii.full};
  border: 0.5px solid transparent;
  white-space: nowrap;
  flex-shrink: 0;

  ${({billTo}) => (billTo === 'self' ? selfPayStyles : parentPayStyles)}
`

export const LocationActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
`

export const LocationActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${theme.space[1]};
  font-family: ${theme.fonts.body};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.medium};
  color: ${theme.colors.text.primary};
  background: ${theme.colors.bg.primary};
  border: 1px solid ${theme.colors.border.default};
  border-radius: ${theme.radii.md};
  padding: ${theme.space[1]} ${theme.space[3]};
  cursor: pointer;
  white-space: nowrap;
  transition: background-color ${theme.transitions.fast},
    border-color ${theme.transitions.fast};

  &:hover {
    background-color: ${theme.colors.bg.secondary};
    border-color: ${theme.colors.border.strong};
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${theme.colors.input.focusRing};
  }
`

export const OrderButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${theme.space[1]};
  font-family: ${theme.fonts.body};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.medium};
  color: ${theme.colors.action.secondaryText};
  background-color: ${theme.colors.action.secondary};
  border: 1px solid ${theme.colors.border.dark};
  border-radius: ${theme.radii.md};
  padding: ${theme.space[1]} ${theme.space[3]};
  cursor: pointer;
  white-space: nowrap;
  transition: background-color ${theme.transitions.fast};

  &:hover {
    background-color: ${theme.colors.action.secondaryHover};
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${theme.colors.input.focusRing};
  }
`
